import { DELETE_PIN_PARTICIPANT, PARTICIPANT_JITSI_ID } from '.';
import { createTaskQueue } from '../../../modules/util/helpers';
import { NOTIFICATION_TIMEOUT, showNotification } from '../../notifications';

import {
    ALREADY_PARTICIPANT_JOINED,
    DOMINANT_SPEAKER_CHANGED, MUTE_REMOTE_PARTICIPANT,
    PARTICIPANT_HANDLER_JOIN,
    PARTICIPANT_JOINED,
    PARTICIPANT_KICKED,
    PARTICIPANT_LEFT,
    PARTICIPANT_UPDATED,
    PIN_PARTICIPANT, SET_BRIDGE_PARTICIPANT, SET_GROUP_PARTICIPANT, SET_RECORDING_PARTICIPANT,
    SET_VACATED_PARTICIPANT
} from './actionType';

import {
    getParticipantById,
    getParticipantDisplayName
} from './function';

export function setBridgeParticipant(user_id, bridge_session_id) {
    return {
        type: SET_BRIDGE_PARTICIPANT,
        user_id,
        bridge_session_id
    }
}

export function setGroupParticipant(particiapnt) {
    return {
        type: SET_GROUP_PARTICIPANT,
        particiapnt
    }
}

export function assignGroupParticipant({group_id, user_id, role_name}) {
    return (dispatch, getState) => {
        const group = getState()["features/base/participants"].group;

        group.set(user_id, { group_id, user_id, role_name });
        dispatch(setGroupParticipant(group));
    }
}

export function unsetGroupParticipant({ group_id, user_id}) {
    return (dispatch, getState) => {
        const group = getState()["features/base/participants"].group;

        if (group.has(user_id)) group.delete(user_id);
        
        dispatch(setGroupParticipant(group));
    }
}

export function setVacatedParticipant(user_uuid) {
    return {
        type: SET_VACATED_PARTICIPANT,
        user_uuid
    }
}

/**
 * 지배적인 화자가 바뀔 때를 위한 조치
 */
export function dominantSpeakerChanged(user_uuid) {
    return {
        type: DOMINANT_SPEAKER_CHANGED,
        user_uuid
    };
}

/**
 * 회의에서 다른 참가자를 음소거하기 위한 작업
 */
 export function muteRemoteParticipant(id, mediaType, muted) {
    return {
        type: MUTE_REMOTE_PARTICIPANT,
        id,
        mediaType,
        muted
    };
}

/**
 * 참가자가 참가했음을 알림
 */

export function handlerParticipantJoined(participant, isLocal, group_id) {
    return {
        type: PARTICIPANT_JOINED,
        participant,
        isLocal, 
        group_id
    };
}

// const task = createTaskQueue();
export function participantJoined(participant, isLocal, group_id) {
    return {
        type: PARTICIPANT_HANDLER_JOIN,
        participant,
        isLocal,
        group_id
    };
}

export function participantsJoin(participants, group_id) {
    return {
        type: ALREADY_PARTICIPANT_JOINED,
        participants,
        group_id
    };
}

/**
 * 참가자가 회의를 나갔음을 알림
 */
export function participantLeft(participant, group_id) {
    return {
        type: PARTICIPANT_LEFT,
        participant,
        group_id
    };
}

/**
 * 참가자의 역할이 변경되었음을 알림
 */
export function participantRoleChanged(id, role) {
    return (dispatch, getState) => {
        const participant = getParticipantById(getState(), id);
        if (participant) {
            return dispatch(participantUpdated({
                ...participant,
                role
            }));
        }
        
    }    
}

/**
 * 세션 브릿지 아이디 추가
 */
export function participantJitsiId(participant, jitsi_id) {
    participant.jitsi_id = jitsi_id;

    return {
        type: PARTICIPANT_JITSI_ID,
        participant
    };
}

/**
 * 일부 참가자 속성이 변경되었음을 알림
 */
export function participantUpdated(participant = {}) {    
    return {
        type: PARTICIPANT_UPDATED,
        participant
    };
}

/**
 * 참가자가 추방되었음을 알림
 */
export function participantKicked(kicker, kicked) {
    return (dispatch, getState) => {

        dispatch({
            type: PARTICIPANT_KICKED,
            kicked: kicked.getId(),
            kicker: kicker?.getId()
        });

        if (kicked.isReplaced && kicked.isReplaced()) {
            return;
        }

        dispatch(showNotification({
            titleArguments: {
                kicked:
                    getParticipantDisplayName(getState, kicked.getId()),
                kicker:
                    getParticipantDisplayName(getState, kicker.getId())
            },
            titleKey: 'notify.kickParticipant'
        }, NOTIFICATION_TIMEOUT * 2)); // leave more time for this
    };
}

/**
 * 회의 참가자를 고정 (발표자)
 */
export function pinParticipant(participantId, isRemote) {
    
    return {
        type: PIN_PARTICIPANT,
        participantId,
        isRemote
    };
}
export function deletePinParticipant(participantId, isRemote) {
    return {
        type: DELETE_PIN_PARTICIPANT,
        participantId,
        isRemote
    }
}

/**
 * 발언권
 */
export function raiseHand(enabled) {
    return {
        type: LOCAL_PARTICIPANT_RAISE_HAND,
        enabled
    };
}

/**
 * 녹화 참가자
 */
export function setRecordingParticipant(participantId, record) {
    return {
        type: SET_RECORDING_PARTICIPANT,
        participantId, record
    }
}